<script setup lang="ts">
import { ref } from "vue";
import MSimpleSelect from "../MSimpleSelect";
import ColorRender from "./ColorRender.vue";

defineProps<{
  label?: string;
  modelValue: any;
  name?: string;
  instructions?: string;
}>();

const colours = [
  {
    label: "Blue",
    value: "blue",
  },
  {
    label: "Red",
    value: "red",
  },
  {
    label: "Green",
    value: "green",
  },
  {
    label: "Yellow",
    value: "yellow",
  },
];

const selectEl = ref<InstanceType<typeof MSimpleSelect>>();

defineExpose({
  open() {
    return selectEl.value?.open();
  },
});
</script>
<template>
  <m-simple-select
    ref="selectEl"
    :options="colours"
    :label="label"
    :name="name"
    :instructions="instructions"
    :model-value="modelValue"
    @update:model-value="$emit('update:modelValue', $event)"
  >
    <template v-if="modelValue" #prepend>
      <ColorRender :color="modelValue" />
    </template>
    <template #option-section="{ option }">
      <ColorRender class="m-mr-sm" :color="option.value" />
    </template>
  </m-simple-select>
</template>
